// ⚙️ CONFIG: Fill this array with your real press mentions.
// Each item can use EITHER a `logo` (image path in /public/assets) OR a `name`
// (styled as an elegant serif wordmark). Leave the array empty [] to hide
// this section entirely.
//
// Examples:
//   { name: "Well+Good" }
//   { name: "mindbodygreen", href: "https://mindbodygreen.com/…" }
//   { logo: "/assets/press/forbes.svg", alt: "Forbes", href: "…" }
const PRESS = [
  // { name: "Well+Good", href: "" },
  // { name: "mindbodygreen", href: "" },
  // { name: "Vogue", href: "" },
  // { name: "Forbes Women", href: "" },
  // { name: "Goop", href: "" },
];

const FeaturedIn = () => {
  if (!PRESS.length) return null;

  return (
    <section
      data-testid="featured-in-section"
      className="py-20 md:py-24 px-6 md:px-12 bg-[#F9F8F6] border-y border-[#2C3524]/8"
    >
      <div className="max-w-6xl mx-auto">
        <p className="text-center text-[11px] tracking-[0.3em] uppercase text-[#4A5543]/70 mb-10">
          As Featured In
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-8 md:gap-x-16">
          {PRESS.map((item, i) => {
            const inner = item.logo ? (
              <img
                src={item.logo}
                alt={item.alt || item.name || "Press logo"}
                className="h-8 md:h-10 w-auto object-contain opacity-70 hover:opacity-100 grayscale hover:grayscale-0 transition-all duration-300"
              />
            ) : (
              <span className="font-heading text-2xl md:text-3xl text-[#2C3524]/70 hover:text-[#2C3524] italic transition-colors duration-300 tracking-tight">
                {item.name}
              </span>
            );
            return item.href ? (
              <a
                key={i}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`press-item-${i}`}
                className="inline-block"
              >
                {inner}
              </a>
            ) : (
              <div key={i} data-testid={`press-item-${i}`} className="inline-block">
                {inner}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturedIn;
